export default IconBrandJuejin => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-juejin" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M2 12l10 7.422l10 -7.422" />
  <path d="M7 9l5 4l5 -4" />
  <path d="M11 6l1 .8l1 -.8l-1 -.8z" />
</svg>`;